module.exports = __webpack_public_path__ + "static/media/NewHelloFarmerLogo.f2ffb7a5.png";